import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';

import { DeviceViewModel } from 'services/device/domain/model/DeviceModel';
import { DeviceModelState } from 'services/device/domain/model/DeviceModelState';
import { DeviceUnarchiveForm } from 'services/device/presentation/ui/device-action/device-unarchive-form/DeviceUnarchiveForm';
import { DeviceUnarchiveFailedNotification } from 'services/device/presentation/ui/device-action/device-unarchive-modal/DeviceUnarchiveFailedNotification';
import { updateDevice } from 'services/device/store/devicesSlice';

import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { ModalDialogueHeight } from 'presentation/ui/compositions/modal-dialogue/ModalDialogueHeight';

export interface DeviceUnarchiveModalProps {
	device: DeviceViewModel
	onDismiss?: () => void;
}

export const DeviceUnarchiveModal = (props: DeviceUnarchiveModalProps): JSX.Element => {
	const { device, onDismiss } = props;

	const deviceActionStatus = useTypedSelector(state => state.devices.actionStatus);

	const dispatch = useDispatch();

	useEffect(() => {
		if (deviceActionStatus === AsyncReducerStatus.UPDATED) {
			onDismiss();
		}
	}, [deviceActionStatus, onDismiss]);

	const handleUpdate = (): void => {
		dispatch(updateDevice({
			...device,
			...{
				State: DeviceModelState.ACTIVE
			}
		}));
	};

	const renderModalContent = () => {
		let modalContent: JSX.Element = null;

		switch (deviceActionStatus) {
			case AsyncReducerStatus.IDLE:
				modalContent =
					<DeviceUnarchiveForm
						device={device}
						onUpdate={handleUpdate}
						onDismiss={onDismiss}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modalContent = <DeviceUnarchiveFailedNotification
					onDismiss={onDismiss}
				/>;
				break;
		}

		return modalContent;
	};

	return (
		<ModalDialogue height={ModalDialogueHeight.HEIGHT_FLEX}>
			{renderModalContent()}
		</ModalDialogue>
	);
};
